export default "__VITE_ASSET__DCFGV2lH__"